import { render } from "./Bio.vue?vue&type=template&id=15d512e7&scoped=true"
import script from "./Bio.vue?vue&type=script&lang=js"
export * from "./Bio.vue?vue&type=script&lang=js"

import "./Bio.vue?vue&type=style&index=0&id=15d512e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d512e7"]])

export default __exports__